<template>
  <div class="notification">
    <img src="@/assets/images/promotions/tradingContest/announcement-icon.png" />

    <i18n path="promotion.common.countdownTimer.preText" tag="p">
      <template v-slot:campaignName>
        {{ campaignName }}
      </template>

      <template v-slot:time>
        <span class="highlight">
          <span v-if="day && remainingDays">{{
            `${remainingDays} ${$t('promotion.common.countdownTimer.days')}`
          }}</span>
          &nbsp;
          <span v-if="hour && remainingHours">{{
            `${remainingHours} ${$t('promotion.common.countdownTimer.hours')}`
          }}</span>
          &nbsp;
          <span v-if="minute && remainingMinutes">{{
            `${remainingMinutes} ${$t('promotion.common.countdownTimer.minutes')}`
          }}</span>
          &nbsp;
          <span v-if="second && remainingSeconds">{{
            `${remainingSeconds} ${$t('promotion.common.countdownTimer.seconds')}`
          }}</span>
        </span>
      </template>
    </i18n>
  </div>
</template>

<script>
import PaginationWithApi from '@/components/PaginationWithApi.vue';
import moment from 'moment';

export default {
  name: 'CountdownTimer',
  components: { PaginationWithApi },
  props: {
    campaignName: {
      type: String,
      default: ''
    },
    targetTime: {
      type: [Number, String], // timestamp in milliseconds
      default: undefined
    },
    day: {
      type: Boolean,
      default: false
    },
    hour: {
      type: Boolean,
      default: false
    },
    minute: {
      type: Boolean,
      default: false
    },
    second: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      remainingDays: undefined,
      remainingHours: undefined,
      remainingMinutes: undefined,
      remainingSeconds: undefined
    };
  },
  mounted() {
    setInterval(() => {
      this.startTimer();
    }, 1000);
  },
  methods: {
    startTimer() {
      const timeNow = moment();
      const countDownToTime = moment.unix(this.targetTime / 1000);
      const duration = moment.duration(countDownToTime.diff(timeNow));

      this.remainingDays = Math.floor(duration.asDays());
      this.remainingHours = duration.hours();
      this.remainingMinutes = duration.minutes();
      this.remainingSeconds = duration.seconds();

      if (this.remainingDays == 0 && this.remainingHours == 0 && this.remainingMinutes == 0) {
        this.$emit('refresh');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.notification {
  margin-bottom: 20px;
  background: #fffbf0;
  padding: 10px 20px;
  border-radius: 12px;
  display: flex;
  gap: 10px;
  font-size: 12px;

  p {
    align-content: center;
  }

  @media (max-width: 1024px) {
    margin-bottom: 0;
  }
}

[dir='rtl'] .notification > img {
  transform: scaleX(-1);
}

.highlight {
  color: $primary-blue;
  font-weight: 600;
}
</style>
